/* eslint-disable react/no-array-index-key */
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'wouter';

import useWindowSize from '../../hooks/useWindowSize';

import { useMenuOpen } from '../../contexts/SiteContext';
import { useUser } from '../../contexts/UserContext';
import BurgerButton from '../buttons/Burger';
import StyledButton from '../buttons/StyledButton';
import Menu from '../menus/Menu';
import Mobile from '../menus/Mobile';
import Title from '../typography/Title';

import logo from '../../../img/logo-projections-new.png';
import styles from '../../../styles/partials/header.module.css';

const propTypes = {
    menu: PropTypes.arrayOf(PropTypes.shape({})),
    footerMenu: PropTypes.arrayOf(PropTypes.shape({})),
    button: PropTypes.shape({}),
    isPro: PropTypes.bool,
    isConnected: PropTypes.bool,
    catalog: PropTypes.shape({}),
    className: PropTypes.string,
};

function Header({
    menu = null,
    footerMenu = null,
    button = null,
    isPro = false,
    isConnected = false,
    catalog = null,
    className,
}) {
    const route = useUrlGenerator();
    const { locale } = useIntl();
    const user = useUser();
    const { url = null } = button || {};
    const { menuOpen: mobileMenuOpen, setMenuOpen: setMobileMenuOpen } = useMenuOpen();
    const { url: catalogUrl = null } = catalog || {};

    const { width = null } = useWindowSize();
    const isSmall = width <= 768;

    useEffect(() => {
        if (mobileMenuOpen && width > 768) {
            setMobileMenuOpen(false);
        }
    }, [width, mobileMenuOpen, setMobileMenuOpen]);

    const onClickBurger = useCallback(() => {
        setMobileMenuOpen(!mobileMenuOpen);
    }, [mobileMenuOpen, setMobileMenuOpen]);

    const onCloseMenu = useCallback(() => {
        setMobileMenuOpen(false);
    }, [setMobileMenuOpen]);

    const catalogElement =
        catalogUrl !== null ? (
            <StyledButton
                className={styles.catalogButton}
                href={catalogUrl}
                size="small"
                external
                target="_blank"
            >
                <FormattedMessage defaultMessage="Catalog" description="Menu label" />
            </StyledButton>
        ) : null;

    return (
        <div
            className={classNames([
                styles.container,
                { [styles.isSmall]: isSmall, [className]: className !== null },
            ])}
        >
            <div className={styles.top}>
                <div className={styles.logo}>
                    <Link href={`/${locale}`} className={styles.link} onClick={onCloseMenu}>
                        <img className={styles.logoImage} src={logo} alt="Logo" />
                        {isPro && isConnected ? (
                            <Title className={styles.logoTitle} size="medium" gradient>
                                <FormattedMessage
                                    defaultMessage="Pro corner"
                                    description="Page title"
                                />
                            </Title>
                        ) : null}
                    </Link>
                </div>
                <div className={styles.buttons}>
                    {!isSmall ? (
                        <>
                            {/* <a
                                className={styles.textLink}
                                href={`/${locale === 'fr' ? 'en' : 'fr'}`}
                            >
                                {locale === 'fr' ? (
                                    <FormattedMessage
                                        defaultMessage="En"
                                        description="Button label"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Fr"
                                        description="Button label"
                                    />
                                )}
                            </a> */}
                            {user === null ? (
                                <>
                                    <Link className={styles.textLink} href={route('login')}>
                                        <FormattedMessage
                                            defaultMessage="Login"
                                            description="Button label"
                                        />
                                    </Link>
                                    {catalogElement}
                                    <StyledButton className={styles.button} href={url} size="small">
                                        <FormattedMessage
                                            defaultMessage="Pro corner"
                                            description="Button label"
                                        />
                                    </StyledButton>
                                </>
                            ) : (
                                <>
                                    <a className={styles.textLink} href={route('logout')}>
                                        <FormattedMessage
                                            defaultMessage="Logout"
                                            description="Button label"
                                        />
                                    </a>
                                    {catalogElement}
                                    {!isPro ? (
                                        <StyledButton
                                            className={styles.button}
                                            href={route('pro.home')}
                                            size="small"
                                        >
                                            <FormattedMessage
                                                defaultMessage="Pro corner"
                                                description="Button label"
                                            />
                                        </StyledButton>
                                    ) : (
                                        <StyledButton
                                            className={styles.button}
                                            href={route('home')}
                                            size="small"
                                        >
                                            <FormattedMessage
                                                defaultMessage="Home"
                                                description="Button label"
                                            />
                                        </StyledButton>
                                    )}
                                </>
                            )}
                        </>
                    ) : (
                        <BurgerButton
                            className={styles.burger}
                            open={mobileMenuOpen}
                            onClick={onClickBurger}
                        />
                    )}
                </div>
            </div>
            {menu !== null && menu.length > 0 && !isPro ? (
                <Menu className={styles.menu} itemsClassName={styles.menuItems} items={menu} />
            ) : null}
            {isSmall ? (
                <Mobile
                    className={classNames([styles.mobile, { [styles.open]: mobileMenuOpen }])}
                    items={menu !== null ? menu.concat(footerMenu || []) : menu || []}
                    open={mobileMenuOpen}
                    onClickItem={onCloseMenu}
                    proUrl={url}
                    catalogUrl={catalogUrl}
                />
            ) : null}
        </div>
    );
}

Header.propTypes = propTypes;

export default Header;
